import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { NestApiProvider } from "../../nest-api";

@Injectable()
export class Sf6EmployeeDisciplinaryProvider {

  private service: string = '';
  private model: string = 'sf6s/disciplinary';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(empId: string, lang: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = {empId : empId , language: lang};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/sf6-employee-disciplinary.api.ts